import ApiService from "../ApiService";
const { REACT_APP_REST_ENDPOINT } = process.env;

export default class PresenzeService {
  static getRegistroPresenzeByParams = (params) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/registro-presenze-lezioni/find`;
      ApiService.postRudeRequest(resolve, reject, url, params)
  });
  };

  static createRegistroPresenze = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/registro-presenze-lezioni/create`;
      ApiService.postRequest(resolve, reject, url, data);
    });
  };

  static updateRegistroPresenze = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/registro-presenze-lezioni/update`;
      ApiService.putRequest(resolve, reject, url, data);
    });
  };

  static deleteRegistroPresenze = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/registro-presenze-lezioni/delete`;
      ApiService.delete(resolve, reject, url, data);
    });
  };
}
